
<template>
  <Layout>
    <b-modal
        id="modalUpload"
        scrollable
        title="Subir archivo"
        title-class="font-18"
        size="lg"
        no-close-on-esc
        hide-footer
        centered
    >
      <subirArchivos v-on:upload-complete="uploadComplete" />
    </b-modal>
    <b-modal
        id="modalPagos"
        scrollable
        title="Pago"
        title-class="font-18"
        size="xl"
        hide-footer
    >
      <b-overlay :show="isLoadingModal" rounded="sm">
        <form class="needs-validation" @submit.prevent="submitPagos">
        <b-tabs  card >
          <b-tab title="Datos" active>
              <div class="row">
                  <div class="form-group col-md-12">
                    <label>Expediente</label>
                    <v-select
                        :options="expedientes"
                        label="obra_expediente"
                        :reduce="desc=>desc.expediente_id"
                        v-model="pago.expediente_id"
                        @input="actualizarGasto()"
                    />
                  </div>
              </div>
              <div class="row">
                <div class="form-group col-md-12">
                  <label>Gasto</label>
                  <v-select
                      :options="lista_gastos"
                      label="descripcion"
                      v-model="gasto_actual"
                  />
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-6">
                  <label>RUC o DNI</label>
                  <div class="input-group mb-3">
                    <input type="text" class="form-control"
                           placeholder="Ingrese el ruc o dni"
                           aria-describedby="button-addon2"
                           v-model="pago.ruc"
                           :disabled="disable_ruc"
                           :class="{ 'is-invalid': submittedPagos && $v.pago.ruc.$error }"
                    >
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary"
                              type="button"
                              id="button-addon2"
                              v-on:click="buscarDocumento"
                      >
                        <i class="fa fa-search"></i>
                        Buscar
                        <b-spinner small v-show="loadingRuc"></b-spinner>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label>Denominación (Razón social)</label>
                  <input
                      class="form-control" v-model="pago.denominacion"
                      :disabled="disable_denominacion"
                      :class="{ 'is-invalid': submittedPagos && $v.pago.denominacion.$error }"
                  />
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-6">
                  <label>Número documento</label>
                  <select
                      class="form-control"
                      v-model="pago.tipo_documento"
                      :class="{ 'is-invalid': submittedPagos && $v.pago.tipo_documento.$error }"
                  >
                    <option value="01">Factura</option>
                    <option value="03">Boleta</option>
                    <option value="100">Declaración jurada</option>
                    <option value="110">Otros</option>
                  </select>
                  <div v-if="submittedPagos && $v.pago.tipo_documento.$error" class="invalid-feedback">
                    <span v-if="!$v.pago.tipo_documento.required">Este valor es requerido.</span>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label>Nº documento</label>
                  <input
                      class="form-control"
                      v-model="pago.numero_documento"
                      :class="{ 'is-invalid': submittedPagos && $v.pago.numero_documento.$error }"
                  >
                  <div v-if="submittedPagos && $v.pago.numero_documento.$error" class="invalid-feedback">
                    <span v-if="!$v.pago.numero_documento.required">Este valor es requerido.</span>
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="form-group col-md-6">
                  <label>Cajas</label>
                  <v-select
                      :options="cajas"
                      label="nombre"
                      :reduce="desc=>desc.id"
                      v-model="pago.caja_id"
                  />
                </div>
                <div class="form-group col-md-6">
                  <label>Fecha</label>
                  <VueCtkDateTimePicker
                      v-model="pago.fecha"
                      :locale="'es'"
                      :input-size="'sm'"
                      :format="'YYYY-MM-DD'"
                      :formatted="'YYYY-MM-DD'"
                      :range="false"
                      :auto-close="true"
                      :only-date="true"
                      :no-header="true"
                      :class="{ 'is-invalid': submittedPagos && $v.pago.fecha.$error }"
                  />
                  <!--style="position: fixed;width: 180px-->
                  <!--:class="{ 'is-invalid': submittedModificarPartida && $v.partida_modificar.fecha.$error }"-->
                  <div v-if="submittedPagos && $v.pago.fecha.$error" class="invalid-feedback">
                    <span v-if="!$v.pago.fecha.required">Este valor es requerido.</span>
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="form-group col-md-6">
                  <label>Monto</label>
                  <input
                      class="form-control" v-model="pago.monto"
                      :disabled="disable_monto"
                      :class="{ 'is-invalid': submittedPagos && $v.pago.monto.$error }"
                  />
                  <div v-if="submittedPagos && $v.pago.monto.$error" class="invalid-feedback">
                    <span v-if="!$v.pago.monto.required">Este valor es requerido.</span>
                    <span v-if="!$v.pago.monto.decimal">Solos se adminte numeros.</span>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label>Clasificador</label>
                  <v-select
                      :options="clasificadores"
                      label="nombre"
                      :reduce="desc=>desc.id"
                      v-model="pago.clasificador_id"
                  />
                  <!--
                    :class="{ 'is-invalid': submittedPagos && $v.pago.monto.$error }"
                    <div v-if="submittedPagos && $v.pago.monto.$error" class="invalid-feedback">
                    <span v-if="!$v.pago.monto.required">Este valor es requerido.</span>
                    <span v-if="!$v.pago.monto.decimal">Solos se adminte numeros.</span>
                  </div>-->
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-12">
                  <label>Descripcion</label>
                  <input
                      class="form-control" v-model="pago.descripcion"
                      :class="{ 'is-invalid': submittedPagos && $v.pago.descripcion.$error }"
                  />
                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-12">
                  <label>Observaciones</label>
                  <textarea
                      class="form-control" v-model="pago.observaciones"

                  />
                </div>
              </div>


          </b-tab>
          <b-tab title="Archivos">
            <div class="row">
              <button type="button" class="btn btn-outline-primary m-2" v-show="$can('pagos-modificar')" v-on:click="abrirCarga">Cargar fotos</button>
            </div>
            <div class="row font-size-12">
              <table class="table">
                <thead>
                <th>ID</th>
                <th>Archivos</th>
                <th>Op</th>
                </thead>
                <tbody>
                <tr v-for="(data,index) in pago.archivos"  v-bind:key="index">
                  <td>
                    {{ data.id }}
                  </td>
                  <td>
                    <a :href="server + '/storage/' + data.nombre"  target="_blank" >
                      <img :src="server + '/image/' + data.nombre" style="max-width: 200px; height: auto; " />
                    </a>

                  </td>
                  <td>
                    <button
                        v-show="$can('pagos-modificar')"
                        class="btn btn-danger btn-icon btn-sm ml-1"
                        type="button"
                        v-on:click="borrarArchivo(index)" >
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>

            </div>
          </b-tab>
        </b-tabs>
        <div class="row">
          <div class="col-md-12 text-right">
            <button class="btn btn-primary" type="submit">
              <i class="fa fa-save"></i>
              Guardar</button>
          </div>
        </div>
        </form>
      </b-overlay>
    </b-modal>
    <PageHeader :title="title" :items="items" />
    <button  type="button"   class="btn btn-primary mb-3" v-on:click="nuevo">Nuevo</button>
    <div class="row">
      <div class="form-group col-md-12">
        <label>Buscar</label>
        <div class="input-group">
          <input
              type="text"
              v-model="terminoBusqueda"
              class="form-control"
              placeholder="Buscar por numero de documento, concepto, monto."
              @input="buscarPorTermino"
          >
        </div>
     </div>

    </div>
    <vue-good-table
        ref="tabla"
        mode="remote"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
        @on-per-page-change="onPerPageChange"

        :totalRows="totalRecords"
        :isLoading.sync="isLoading"
        :pagination-options="{
              enabled: true,
              }"
        :rows="rows"
        :columns="columns"
        styleClass="vgt-table striped smalltable"
    >
      <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'acciones'">
              <!--<button class="btn btn-success btn-icon btn-sm mr-1"><i class="fa fa-eye"></i></button>-->
              <button class="btn btn-primary btn-icon btn-sm" v-on:click="modificar(props.row.id)"><i class="fa fa-edit"></i></button>
              <button class="btn btn-danger btn-icon btn-sm ml-1" v-on:click="borrar(props.row.id)"><i class="fa fa-trash"></i></button>

            </span>
        <span v-else>
              {{props.formattedRow[props.column.field]}}
        </span>
      </template>
    </vue-good-table>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {decimal,required} from "vuelidate/lib/validators";
import subirArchivos from "@/components/subir-archivos.vue";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Caja chica lista",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    subirArchivos,
    Layout,
    PageHeader,
  },
  data() {
    return {

      title: "Pagos",
      items: [
        {
          text: "Finanzas",
          href: "/",
        },
        {
          text: "Pagos",
          active: true,
        },
      ],

      isLoading: false,
      columns: [
        {
          label: 'id',
          field: 'id',
        },
        {
          label: 'Obra',
          field: 'obra',
        },
        {
          label: 'Caja',
          field: 'caja',
        },
        {
          label: 'Fecha',
          field: 'fecha',
        },
        {
          label: 'Descripción',
          field: 'descripcion',
        },
        {
          label: 'Monto',
          field: 'monto',
        },
        {
          label:'Numero doc',
          field:'numero_documento'
        },
        {
          label: 'Acciones',
          field: 'acciones',
          width: '12%'
        }
      ],
      rows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: '',
        },
        page: 1,
        perPage: 10
      },
      isLoadingModal:false,
      disable_monto:false,
      disable_ruc:false,
      disable_denominacion:false,
      disable_clasificador:false,
      submittedPagos:false,
      pago:{
        id:0,
        denominacion:''
      },
      expedientes:[],
      cajas:[],
      expediente_id:null,
      caja_id:null,
      server:process.env.VUE_APP_BACKEND,
      loadingRuc:false,
      clasificadores:[],
      lista_gastos:[],
      gasto_actual:null,
      terminoBusqueda:""
    };
  },

  methods: {
    buscarPorTermino(){
      clearTimeout(this.debounceTimer);
      // Establecer un nuevo temporizador de medio segundo
      this.debounceTimer = setTimeout(() => {
        this.serverParams.page=1;
        this.$refs['tabla'].reset();
        //this.$refs['tabla'].reset();
        this.loadItems();
        // Aquí puedes realizar las acciones que necesites
      }, 500); //
    },
    buscarDocumento(){
      if(!this.$isNumeric(this.pago.ruc)){
        this.$swal('Cuidado',"Solo seacepta",'warning');
      }

      if(this.pago.ruc.length ===11){
        this.loadingRuc=true;
        this.$buscarPorRUC(this.pago.ruc,
            (response)=>{
              console.log(response);
              if(response.data.success){
                //console.log(response.data.denominacion_nombre_completo);
                this.pago.denominacion=response.data.denominacion_nombre_completo;
                this.loadingRuc=false;
              }
              else
              {
                this.$swal('Cuidado',"Error no encontrado",'warning');
                this.loadingRuc=false;
              }
            }
            ,()=>{} );
      }
      else if(this.pago.ruc.length ===8){
        this.loadingRuc=true;
        this.$buscarDNI(this.pago.ruc,
            (response)=>{
              console.log(response);
              if(response.data.success){
                //console.log(response.data.denominacion_nombre_completo);
                this.pago.denominacion=response.data.nombre_completo;
                this.loadingRuc=false;
              }
              else
              {
                this.$swal('Cuidado',"Error no encontrado",'warning');
                this.loadingRuc=false;
              }
            }
            ,()=>{} );
      }
      else{
        this.$swal('Cuidado',"La longitud debe ser de 8 digitos (DNI) u 11 digitos (RUC).",'warning');
      }

    },

    uploadComplete(files){
      this.isLoading=true;
      this.$bvModal.hide("modalUpload");
      this.pago.archivos.push(files[0]);
      /*this.axios.post(process.env.VUE_APP_BACKEND + "/api/pagos/archivos",
          {
            files:files,
            pago_id:this.pago.id
          })
          .then(()=>{
            this.$bvModal.hide("modalUpload");
            this.actualizar();
          })
          .finally(()=>this.isLoading=false)*/
    },
    actualizarGastoIndex(){
      this.isLoadingModal=true;
      this.axios.get(process.env.VUE_APP_BACKEND + "/api/gastos/recursos/ccei/"+this.pago.expediente_id)
          .then((response)=>{
            this.lista_gastos=response.data;
            console.log(this.lista_gastos);
            for(var i=0;i<this.lista_gastos.length;i++){
              if(this.lista_gastos[i].id==this.pago.gasto_id){
                this.gasto_actual=this.lista_gastos[i];
                break;
              }
            }
          })
          .catch(()=>{
            this.$swal('Cuidado',"Error",'warning');
          })
          .finally(()=>this.isLoadingModal=false)
    },
    actualizarGasto(){
      this.isLoadingModal=true;
      this.axios.get(process.env.VUE_APP_BACKEND + "/api/gastos/recursos/ccei/"+this.pago.expediente_id)
          .then((response)=>{
            this.lista_gastos=response.data;
            //this.$bvModal.show("modalPagos");
            //this.loadItems();
            //this.actualizar();
          })
          .catch(()=>{
            this.$swal('Cuidado',"Error",'warning');
          })
          .finally(()=>this.isLoadingModal=false)
    },
    actualizar(){
      this.isLoadingModal=true;
      this.axios.get(process.env.VUE_APP_BACKEND + "/api/pagos/"+this.pago.id)
          .then((response)=>{
            this.pago=response.data;
            //this.$bvModal.show("modalPagos");
            //this.loadItems();
            //this.actualizar();
          })
          .catch(()=>{
            this.$swal('Cuidado',"Error",'warning');
          })
          .finally(()=>this.isLoadingModal=false)
    },
    abrirCarga(){
      this.$bvModal.show("modalUpload");
    },
    submitPagos(){
      this.submittedPagos = true;
      // stop here if form is invalid
      this.$v.$touch();
      if(this.$v.pago.$error===false){
        this.guardar();
      }
      else
      {
        alert("Formulario no valido")
      }
    },
    nuevo(){
      this.submittedPagos=false;
      this.gasto_actual=null;
      this.pago={
        id:0,
        gasto_id:null,
        denominacion: '',
        archivos:[]
      };
      this.$bvModal.show("modalPagos");
    },
    modificar(id){
      this.isLoading=true;
      this.lista_gastos=[];
      this.gasto_actual=null;

      this.axios.get(process.env.VUE_APP_BACKEND + "/api/pagos/"+id)
          .then((response)=>{
            this.pago=response.data;
            this.$bvModal.show("modalPagos");
            this.actualizarGastoIndex();
          })
          .catch(()=>{
            this.$swal('Cuidado',"Error",'warning');
          })
          .finally(()=>this.isLoading=false)

    },
    guardar(){
      console.log(this.pago);
      if(this.pago.id!=0){
        this.isLoadingModal=true;
        console.log(this.gasto_actual);
        if(this.gasto_actual!=null){
          this.pago.gasto_id=this.gasto_actual.id;
        }
        else{
          this.pago.gasto_id=null;
        }
        console.log(this.pago);
        this.axios.put(process.env.VUE_APP_BACKEND + "/api/pagos/"+this.pago.id,this.pago)
            .then(()=>{
              this.$bvModal.hide("modalPagos");
              this.loadItems();
              //this.actualizar();
            })
            .catch(()=>{
              this.$swal('Cuidado',"Error",'warning');
            })
            .finally(()=>this.isLoadingModal=false)
      }
      else
      {
        this.isLoadingModal=true
        if(this.gasto_actual!=null){
          this.pago.gasto_id=this.gasto_actual.id;
        }
        this.axios.post(process.env.VUE_APP_BACKEND + "/api/pagos",this.pago)
            .then(()=>{
              this.$bvModal.hide("modalPagos");
              this.loadItems();
              //this.actualizar();
            })
            .catch(()=>{
              this.$swal('Cuidado',"Error",'warning');
            })
            .finally(()=>this.isLoadingModal=false)
      }

    },
    decimal(value) {
      if (value === null) {
        return '-'
      } else {
        return parseFloat(value).toFixed(2)
      }
    },
    borrarArchivo(index){
      this.pago.archivos.splice(index,1);
    },
    borrar(id) {
      this.$swal.fire({
        title: '¿Esta seguro?',
        text: "No se puede revertir esta accion!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Si, borralo!'
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.axios.delete(process.env.VUE_APP_BACKEND + '/api/pagos/' + id)
              .catch(() => {
                this.$swal('error', 'Error eliminando', 'error');
              })
              .finally(
                  () => {
                    this.isLoading = false;
                    this.loadItems();
                  }
              );
        }
      })

    },
    onSearch: function (params) {
      this.updateParams({page: params.page});
      this.updateParams({searchTerm: params.searchTerm});
      this.loadItems();
    },
    say: function (message) {
      alert(message)
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({perPage: params.currentPerPage});
      this.loadItems();
    },

    onSortChange(params) {
      this.updateParams({
        sort: [{
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        }],
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },
    // load items is what brings back the rows from server
    loadItems() {
      this.isLoading = true;
      this.serverParams.terminoBusqueda=this.terminoBusqueda;
      this.axios.get(process.env.VUE_APP_BACKEND + '/api/pagos/tabla', {'params': this.serverParams})
          .then((response) => {
            //console.log(response.data.data);
            this.totalRecords = response.data.total_records;
            this.rows = response.data.data;
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
            //console.log(error);
          });
    },

  },
  mounted() {
    this.loadItems();
    this.$cargarExpedientes( (res)=>{
      this.expedientes=res.data
    },()=>{});
    this.$cargarCajas( (res)=>{
      this.cajas=res.data
    },()=>{});
    this.$cargarClasificadores( (res)=>{
      this.clasificadores=res.data
    },()=>{});
  },
  validations: {
    pago:{
      ruc:{required},
      denominacion:{required},
      fecha:{required},
      tipo_documento:{required},
      numero_documento:{required},
      monto:{required,decimal},
      descripcion:{required},
    },

  },
};
</script>

<style>
.smalltable {
  font-size: 12px !important;
}

</style>
